import { genericUpsellOptionsDefault } from '@basket/types/BasketUpsellGenericContext';
import { createContext } from 'preact/compat';
export const optionsDefaults = {
    ...genericUpsellOptionsDefault,
    type: 'simple-form',
    item: {},
    buttonText: 'Add to Booking',
};
export const BasketUpsellSimpleFormCTX = createContext(optionsDefaults);
